/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../../spine/options_pb.js');
var spine_core_command_pb = require('../../../../spine/core/command_pb.js');
goog.exportSymbol('proto.spine.system.server.CommandEnrichment', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.CommandEnrichment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.CommandEnrichment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.CommandEnrichment.displayName = 'proto.spine.system.server.CommandEnrichment';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.CommandEnrichment.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.CommandEnrichment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.CommandEnrichment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.CommandEnrichment.toObject = function(includeInstance, msg) {
  var f, obj = {
    command: (f = msg.getCommand()) && spine_core_command_pb.Command.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.CommandEnrichment}
 */
proto.spine.system.server.CommandEnrichment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.CommandEnrichment;
  return proto.spine.system.server.CommandEnrichment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.CommandEnrichment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.CommandEnrichment}
 */
proto.spine.system.server.CommandEnrichment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_core_command_pb.Command;
      reader.readMessage(value,spine_core_command_pb.Command.deserializeBinaryFromReader);
      msg.setCommand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.CommandEnrichment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.CommandEnrichment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.CommandEnrichment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.CommandEnrichment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommand();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_core_command_pb.Command.serializeBinaryToWriter
    );
  }
};


/**
 * optional spine.core.Command command = 1;
 * @return {?proto.spine.core.Command}
 */
proto.spine.system.server.CommandEnrichment.prototype.getCommand = function() {
  return /** @type{?proto.spine.core.Command} */ (
    jspb.Message.getWrapperField(this, spine_core_command_pb.Command, 1));
};


/** @param {?proto.spine.core.Command|undefined} value */
proto.spine.system.server.CommandEnrichment.prototype.setCommand = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.CommandEnrichment.prototype.clearCommand = function() {
  this.setCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.CommandEnrichment.prototype.hasCommand = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.spine.system.server);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../../known_type_parsers.js');

proto.spine.system.server.CommandEnrichment.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.CommandEnrichment.fromObject(jsObject);
};

proto.spine.system.server.CommandEnrichment.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.CommandEnrichment();
  
  if (obj.command !== undefined) {
    if (obj.command === null) {
      msg.setCommand(null);
    } else {
      let value = proto.spine.core.Command.fromObject(obj.command);
      msg.setCommand(value);
    }
  }
  return msg;
};
